import userTypes from 'utilities/user-type';
import templateUrl from './user-add-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    accessLevels: '<',
    onUserChanged: '&',
    requireUserTypeSelection: '<'
  },
  controller: class UserAddFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.user = this.user || {};
      this.userTypes = userTypes;
    }

    onSubmit() {
      this.onUserChanged(
        this.EventEmitter({
          user: this.user
        })
      );
    }

    setSelectedCompany({ company }) {
      this.user.TypeReferenceId = (company && company.MemberId) || null;
    }

    setSelectedRegulator({ regulator }) {
      this.user.TypeReferenceId = (regulator && regulator.RegulatorId) || null;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/user-add-form/user-add-form.component.js